import React from "react";
import { Link, navigate } from "gatsby";
import "./category-filter.scss";

const CategoryFilter = ({ posts, selectedCategory }) => {
  const uniqueCategories = posts.reduce((acc, post) => {
    const categories = post.categories?.nodes || [];

    categories.forEach((category) => {
      if (!acc.find((c) => c.id === category.id)) {
        acc.push(category);
      }
    });

    return acc;
  }, []);

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === "all") {
      navigate("/blog/");
    } else {
      navigate(`/blog/categorie/${value}/`);
    }
  };

  return (
    <div className="category-filter">
      <div className="inner">
        <select
          value={selectedCategory}
          className="category-select"
          aria-label="Filtrer par catégorie"
          // Navigation immédiate requise à la sélection (UX mobile)
          // eslint-disable-next-line jsx-a11y/no-onchange
          onChange={handleSelectChange}
        >
          <option value="all">Toutes les catégories</option>
          {uniqueCategories.map((category) => (
            <option key={category.id} value={category.slug}>
              {category.name}
            </option>
          ))}
        </select>

        <div
          className="category-buttons"
          role="group"
          aria-label="Filtrer par catégorie"
        >
          <Link
            to="/blog/"
            className={`category-button ${
              selectedCategory === "all" ? "active" : ""
            }`}
          >
            Toutes les catégories
          </Link>
          {uniqueCategories.map((category) => (
            <Link
              key={category.id}
              to={`/blog/categorie/${category.slug}/`}
              className={`category-button ${
                selectedCategory === category.slug ? "active" : ""
              }`}
            >
              {category.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
